import { ZipcodeBulkUpsertLandingComponent } from './zipcode-bulk-upsert-landing.component';

export const containers: any[] = [ZipcodeBulkUpsertLandingComponent];

export * from './zipcode-bulk-upsert-landing.component';